import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CMSPath, MAP_ENABLED, DEBUG, WEB_VERSION_ENABLED, INROOMTAB, PROVIDE_INCREASE_DECREASE_ITEM_QUANTITY_ON_HCOM_CHECKOUT_PAGE } from '../../../config/constant'
import { getDeliveryLocation, getStoreInfo, sendOrder, setTotalOrderPrice, setSelectedLocation, setHCommerceSavedOrders, setStoreInfo, changePage, setSelectedSubItemListStoreLevel2, setSelectedSubItemStoreLevel2, getToastPricing } from '../../../action/hcommerce'
import { closeOrderPopUp, setCustomLocation, setMapOpened, setMapSnapshot, setSelectedGuestName } from '../../action/hCommerce2'
import { Link,HashRouter, Redirect } from 'react-router-dom'
import { getGuestInRoom, popupOpenClose } from '../../../action/action'
import { setShowPlaceOrder } from '../../action/hCommerce2';
import $ from 'jquery'
import { formatPriceForDisplay, removeItemHandler } from './itemActions';
import Loader from '../../UI/loader';
import { contScrollToBottom,contScrollToTop,hideScrolltoTopHandler, hideScrolltoBottomHandler } from '../../JS/scroll';
import {withTranslation} from "react-i18next";
import GuestSelectDropdown from '../../UI/SelectDropdown';
import { getServerTime, sendAnalytics } from '../../../action/homeAction';
import OrderDisabledPopup from "./OrderDisabledPopup.jsx";
import { setRegPage, setGuestLogin } from '../../../action/action'
import { setLoginRequired } from '../../action/homeAction'
import { debounce, generateToken, getCleanUrl, getDefaultAnalyticsLabel, validateEmail } from '../../JS/utility'
import { getCdnUrl } from '../../../config/config.js'
import MiniLoader from '../../UI/MiniLoader.jsx'

class PlaceOrderNew extends Component{

    constructor(props) {
        super(props);
        this.state = {
            orderTime: [],
            selectedTime: null,
            selectedRoom: null,
            showMap:false,
            savedOrders:[],
            roomSelectList:false,
            timeSelectList:false,
            showGuestList:false,
            selectedGuest:null,
            guestCount: 1,
            guestCountData: [1,2,3,4,5,6,7,8,9,10],
            showGuestCountList: false,
            placeOrderInProgress:false,
            showScrollToTop:false,
            hideBottomArrow: false,
            deliveryCharges: 0,
            gratitudeMin: 0,
            gratitudeMax: 100,
            gratitudeDefault: 0,
            gratitudeCurrentValue: 0,
            gratitudeAmount: 0,
            taxAmount: 0,
            guestComment: localStorage.getItem("GuestCommentHcommerce"),
            serviceCharge: 0,
            totalAmount: this.props.totalPrice,
            showGratitudeSlider: false,
            showDeliveryCharges: false,
            showTaxAmount: false,
            storeInfoCall: true,
            guestEmail: "",
            isPricingViaToast: this.props.isPricingViaToast ,
            chargesDataViaToast: null
        }
        this.NotMandEmailStoreSku = process.env.REACT_APP_NOT_MAND_EMAIL_SKU ? process.env.REACT_APP_NOT_MAND_EMAIL_SKU.split("_") : [];
        this.base64Map = null;

        this.mapValues=[
            {lat: 27.709356,lng:-82.738884},
            {lat: 27.708614,lng:-82.738701},
            {lat: 27.708853,lng:-82.738044},
            {lat: 27.709490,lng:-82.738435},
        ]
        
    };

    sendGAEvent = (action, message, callback, extraLabelInfo) => {
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
        this.props.sendAnalytics(
            this.props.guestDetail, 
            this.props.currentWidgets.widgetType, 
            action, 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "errorMessage": message && message, "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), ...extraLabelInfo, storeName: this.props.storeInfo.storeName},
            0, 
            this.props.guestIsLoggedIn,
            callback ? callback : false
        );
    }

    retryPriceFetching = async () =>{
        let receivedChargesViaToast = await this.getChargesViaToast(
            {
                serviceValue: this.props.storeInfo.serviceChargeEnabled ? this.props.storeInfo.serviceCharge : 0,
                deliveryValue: this.props.selectedLocation.deliveryCharges,
                gratitudeValue: this.state.gratitudeCurrentValue,
                savedOrders : this.state.savedOrders
            }
        );

        // let gratitudeAmount = receivedChargesViaToast.gratitudeAmount;
        // let taxAmount = receivedChargesViaToast.taxAmount
        // let serviceChargeAmount = receivedChargesViaToast.serviceAmount
        // let deliveryCharges = receivedChargesViaToast.deliveryAmount
        // let totalAmount = receivedChargesViaToast.totalAmount

        // this.setState({gratitudeAmount: this.getRoundOfValue(gratitudeAmount)})
        // this.setState({taxAmount: this.getRoundOfValue(taxAmount)})
        // this.setState({serviceCharge: this.getRoundOfValue(serviceChargeAmount)})
        // this.setState({ deliveryCharges: this.getRoundOfValue(deliveryCharges) })
        // this.setState({ totalAmount: this.getRoundOfValue(totalAmount) });
     }

    // tax ,  serviceCharge , totalAmount, deliveryCharges ;
    getChargesViaToast = async (values)=>{
        const {serviceValue, deliveryValue, gratitudeValue, savedOrders : savedOrders_} = values;
        let savedOrders = typeof savedOrders_ == "string" ? JSON.parse(savedOrders_): savedOrders_;

        this.setState({errorWhilePricingFetching: false});
        this.setState({priceFetchingInProcess:false, chargesDataViaToast: null})

        let orderItemList = [];

        if (savedOrders.length > 0) {
            console.log(savedOrders , typeof savedOrders)
            savedOrders.map((iterator) => {
                // console.log("place order saved orders",iterator);
                let tempAddOn = [];
                iterator.addOns.map((addOnIterator) => {
                    tempAddOn.push({ "itemAddonId": addOnIterator.id, "itemPrice": addOnIterator.actualPrice || addOnIterator.price, quantity : addOnIterator.quantity, addOnGroupId : addOnIterator.addOnGroupId})
                })
                let tempObj = {
                    "storeItemId": iterator.item.id,
                    "quantity": iterator.quantity,
                    "pricePerItem": iterator.item.itemPrice,
                    "addOns": tempAddOn
                }
                orderItemList.push(tempObj);
            })
            console.log("orderItemList", orderItemList)
        } else {
            console.log("please select the food which you want to order.");
            this.props.closeOrderPopUp(true, this.props.t('hcommerce.checkout.cant_place_order'), this.props.t('hcommerce.checkout.cart_empty_msg'),true);

 
            this.setState({ taxAmount: 0})
            this.setState({ totalAmount: 0 });

            return { taxAmount:0, totalAmount: 0}    
        }

        let room = localStorage.getItem("room")
        let guestLogin = room && room != "null"
    

        let payload = {
            "reservationNumber":  guestLogin ? this.props.reservationNo : "",
            "roomNo": room,
            // "serviceCharge": serviceValue,  
            // "deliveryCharge": deliveryValue,   
            // "gratitude" : gratitudeValue,      
            "orderItems": orderItemList
        }

        let taxAmount, totalAmount;

        const callback = (status, data)=>{
            this.setState({priceFetchingInProcess:false});
            if(status){
                this.setState({chargesDataViaToast: data })
                taxAmount = data && data.taxAmount || 0;
                totalAmount = data && data.totalAmount || 0;
            }else{
                this.props.closeOrderPopUp(true, data, this.props.t('hcommerce.fetch_price.error_show'),true);
                this.setState({ errorWhilePricingFetching: true});
                taxAmount=0; totalAmount =0;
            }
        }
        this.setState({priceFetchingInProcess:true})
        await getToastPricing(payload, callback);

        
        this.setState({ taxAmount: this.formatWithoutRounding(taxAmount)})
        this.setState({ totalAmount: this.formatWithoutRounding(totalAmount) });

        return {taxAmount, totalAmount}

    }

    debouncedGetChargesViaToast = debounce(this.getChargesViaToast, 300)

    formatWithoutRounding = (value)=> {
        const precisionLength = Number(this.props.precisionLength) || 2;
        const [integerPart, decimalPart] = value.toString().split(".");
    
        if (!decimalPart) {
            return Number(integerPart);
        }
        
        const truncatedDecimal = decimalPart.slice(0, precisionLength);
        const result = `${integerPart}.${truncatedDecimal}`;
        return Number(result);
    }
    
    setOrderTime = () => {
        let orderTime = [], nextHour;
        if (this.props.serverTime.hours === 23) {
            nextHour = 0;
        } else {
            nextHour = this.props.serverTime.hours + 1;
        }
        if (this.props.serverTime.minutes + 7 > 45) {
            orderTime = [
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:30` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:45` }
            ]
        } else if (this.props.serverTime.minutes + 7 > 30) {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:30` }
            ]
        } else if (this.props.serverTime.minutes + 7 > 15) {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:30` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` }
            ]
        } else {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:15` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:30` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` }
            ]
        }
        
        var now = { time: 'Now'};
        orderTime.splice(0, 0, now);
        this.setState({ orderTime: orderTime });
    }

    setSelectedTime = (time) => {
        this.setState({ selectedTime: time, timeSelectList: !this.state.timeSelectList });
    }

    setSelectedroom = async (selectedLocation, showRoomSelect, maplocation) => {
        if(maplocation){
            this.props.setSelectedGuestName(this.state.selectedGuest)
            this.props.setMapOpened(true)
            if(WEB_VERSION_ENABLED){
                window.location.hash = `/hcommerce2/custom_webmap?mapValues=${this.convertMapValues(selectedLocation.mapValues)}`
            } else {
                window.location.hash = `/hcommerce2/custom_location?mapValues=${this.convertMapValues(selectedLocation.mapValues)}`
            }
        }
        let deliveryCharges = this.formatWithoutRounding(selectedLocation.deliveryCharges ? selectedLocation.deliveryCharges.toString().endsWith("%") ? +(this.props.totalPrice * (parseFloat(selectedLocation.deliveryCharges)/100)) : +selectedLocation.deliveryCharges : 0)
        
        this.props.setSelectedLocation(selectedLocation);
        this.setState({ selectedRoom: selectedLocation.locationNumber,
                        roomSelectList: showRoomSelect == false ? showRoomSelect : !this.state.roomSelectList,
                        deliveryCharges: deliveryCharges,
                        showGratitudeSlider: selectedLocation.gratitudeEnabled && selectedLocation.gratitudeMax && selectedLocation.gratitudeMax > 0,
                        gratitudeDefault: selectedLocation.gratitudeDefault
                    });

        if(deliveryCharges > 0){
            this.setState({showDeliveryCharges: true});
        }


        if(this.state.isPricingViaToast){
            let receivedChargesViaToast;

            this.setState({totalAmount: 0})
            this.setState({gratitudeCurrentValue: selectedLocation.gratitudeEnabled && selectedLocation.gratitudeMax && selectedLocation.gratitudeMax > 0 ? selectedLocation.gratitudeDefault : 0})

            receivedChargesViaToast = await this.getChargesViaToast(
                {
                    serviceValue: this.props.storeInfo.serviceChargeEnabled ? this.props.storeInfo.serviceCharge: 0,
                    deliveryValue: deliveryCharges,
                    gratitudeValue: selectedLocation.gratitudeEnabled && selectedLocation.gratitudeMax && selectedLocation.gratitudeMax > 0 ? selectedLocation.gratitudeDefault : 0,
                    savedOrders: this.state.savedOrders
                }
            );

            // this.setState({gratitudeAmount: this.getRoundOfValue(receivedChargesViaToast.gratitudeAmount) })
                
            // let totalAmount = receivedChargesViaToast.totalAmount;

            // this.setState({ totalAmount: this.getRoundOfValue(totalAmount) })

        }else{
            let gratitudeAmount = 0;
            if(selectedLocation.gratitudeEnabled && selectedLocation.gratitudeMax && selectedLocation.gratitudeMax > 0){
    
                this.setState({totalAmount: 0})
                this.setState({gratitudeCurrentValue: selectedLocation.gratitudeDefault})
    
                gratitudeAmount = this.formatWithoutRounding(selectedLocation.gratitudeDefault * this.props.totalPrice / 100)
                this.setState({gratitudeAmount: gratitudeAmount })
                
            }
    
            let totalAmount = this.formatWithoutRounding(this.props.totalPrice + this.state.taxAmount + this.state.serviceCharge + gratitudeAmount + deliveryCharges)
            this.setState({ totalAmount: totalAmount })
        }

    }

    placeOrder = async () => {
        let selectedGuestDetail = {};
        let tempAddOn = [], tempObj, orderItemList = []
        let guestComment = this.state.guestComment || localStorage.getItem('GuestCommentHcommerce')
        if (this.props.CheckedInGuest.length === 1) {
            this.props.CheckedInGuest.map((iterator) => {
                if (iterator.guestName === this.props.guestDetail.guestName) {
                    selectedGuestDetail = iterator
                }
            })
        }else if(this.props.CheckedInGuest.length > 1){
            this.props.CheckedInGuest.map((iterator) => {
                if (iterator.guestName ===this.state.selectedGuest) {
                    selectedGuestDetail = iterator
                }
            })
        } else {
            console.log("No Guest name slected.");
        }

        if (this.state.savedOrders.length > 0) {
            this.state.savedOrders.map((iterator) => {
                // console.log("place order saved orders",iterator);
                tempAddOn = [];
                iterator.addOns.map((addOnIterator) => {
                    tempAddOn.push({ "itemAddonId": addOnIterator.id, "itemPrice": addOnIterator.actualPrice || addOnIterator.price, quantity : addOnIterator.quantity, addOnGroupId : addOnIterator.addOnGroupId})
                })
                tempObj = {
                    "storeItemId": iterator.item.id,
                    "quantity": iterator.quantity,
                    "pricePerItem": iterator.item.itemPrice,
                    "guestComment": guestComment,
                    "addOns": tempAddOn
                }
                orderItemList.push(tempObj);
            })
            console.log("orderItemList", orderItemList)
        } else {
            console.log("please select the food which you want to order.");
            this.props.closeOrderPopUp(true, this.props.t('hcommerce.checkout.cant_place_order'), this.props.t('hcommerce.checkout.cart_empty_msg'),true);
            return;
        }

        if(this.props.selectedLocation && this.state.selectedRoom){
            if (this.props.selectedLocation.mapLocation == true && (!this.props.mapSnapshot || !this.props.customLocationLink)){
                this.props.closeOrderPopUp(true, this.props.t('hcommerce.checkout.cant_place_order'), this.props.t('hcommerce.checkout.map_details_err'),true);
                return;
            }
        }

        let NotMandEmailStoreSkuBool = false;

        let sendGuestEmail
        if ( this.props.guestIsLoggedIn && this.state.selectedRoom && selectedGuestDetail.id && this.state.selectedTime && this.state.savedOrders.length > 0) {
            sendGuestEmail = false
        } else if ( !this.props.guestIsLoggedIn && this.state.selectedRoom && this.state.guestEmail && this.state.selectedTime && this.state.savedOrders.length > 0) {
            sendGuestEmail = true
        } else if ( !this.props.guestIsLoggedIn  && this.state.selectedRoom && !this.state.guestEmail && this.state.selectedTime && this.state.savedOrders.length > 0 ) {
            if(this.NotMandEmailStoreSku.includes(this.props.hcommerceWidget.storeSku)){
                NotMandEmailStoreSkuBool = true
            }
        } else {
            console.log("All details are not there.");
            this.props.closeOrderPopUp(true, this.props.t('hcommerce.checkout.cant_place_order'), this.props.t('hcommerce.checkout.all_details_err'),true);
            return
        }

        if(!this.props.guestIsLoggedIn && !NotMandEmailStoreSkuBool && !validateEmail(this.state.guestEmail)){
            this.props.closeOrderPopUp(true, this.props.t('hcommerce.checkout.cant_place_order'), "Please enter a valid email address",true);
            return
        }

        var selectedTimeTemp = '';

        console.log(this.state.selectedTime);
        this.setState({placeOrderInProgress:true})
        if (this.state.selectedTime === 'Now') {
            await this.props.getServerTime(status => {
                selectedTimeTemp = `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:${this.props.serverTime.minutes}`;
            });
        }
        else {
            selectedTimeTemp = this.state.selectedTime;
        }
        console.log("selectedTimeTemp",selectedTimeTemp)

        // console.log("this.props.currentWidget",this.props.currentWidget)
        this.props.sendOrder(
            this.state.selectedRoom,
            selectedGuestDetail,
            selectedTimeTemp, guestComment,
            this.state.savedOrders,
            this.props.hcommerceWidget,
            orderItemList,
            this.props.mapSnapshot,
            this.props.customLocationLink,
            this.state.gratitudeAmount,
            this.callBackFromOrderAPI,
            sendGuestEmail ? this.state.guestEmail : NotMandEmailStoreSkuBool ? "no-reply@innspire.com" : null,
            this.state.guestCount,
            // {
            //     taxAmount: this.state.isPricingViaToast ? this.state.taxAmount : undefined,
            //     serviceCharge : this.state.isPricingViaToast ? this.state.serviceCharge : undefined
            // }
        );

    }


    callBackFromOrderAPI = (status, message) => {
        this.setState({placeOrderInProgress:false})
        console.log("hcommerceSessionToken callback");
        if (status) {
            this.props.closeOrderPopUp(true, this.props.t('hcommerce.checkout.thank_you'), this.props.t('hcommerce.checkout.order_placed'),false);
            localStorage.removeItem("savedOrders");
            localStorage.removeItem("GuestCommentHcommerce");
            this.props.setHCommerceSavedOrders([]);
            this.props.setTotalOrderPrice(0);
            this.props.setMapSnapshot(null);
            this.props.setCustomLocation(null);
            this.props.setMapSnapshot(null)
            // this.props.setShowPlaceOrder(false)

            this.sendGAEvent("PLACE ORDER - SUCCESS", "", () => {
                // localStorage.setItem("placeOrderSuccessEventSent", true)
                console.log("hcommerceSessionToken analytics callback");
                localStorage.removeItem('storeLevel1EventSent')
                localStorage.removeItem('storeLevel2EventSent')
                localStorage.removeItem('storeLevel3EventSent')
                localStorage.removeItem("storeInfoFetchEventSent")
                localStorage.removeItem('storeInfoDetailEventSent')
                localStorage.removeItem('placeOrderEventSent')
                localStorage.removeItem('placeOrderSuccessEventSent')
                localStorage.removeItem('addonEventSent')
                localStorage.removeItem("cartEventSent")
                localStorage.removeItem("additionalRequestsEventSent")

                const hcommerceSessionToken = generateToken("hcommerce_")
                console.log("hcommerceSessionToken",hcommerceSessionToken);
                localStorage.setItem("hcommerceSessionToken", hcommerceSessionToken);

        })
        console.log("place order timeout");
        this.props.setShowPlaceOrder(false);
        this.props.setSelectedGuestName(null);
        this.props.setCustomLocation(null);

        this.props.changePage("StoreLevel1");
        this.props.setSelectedSubItemListStoreLevel2([])
        this.props.setSelectedSubItemStoreLevel2(null)
        } else {
            this.props.closeOrderPopUp(true, this.props.t('hcommerce.checkout.sorry'), this.props.t('hcommerce.checkout.order_placed_failed'),true);
            this.sendGAEvent("PLACE ORDER - FAILED",message)
        }
    }

    
    removeItemHandlerCallback = async (savedOrders, totalPrice) => {

        let total = (totalPrice * 100 ) / this.state.gratitudeCurrentValue
        console.log('total******',total, totalPrice, this.state.gratitudeCurrentValue)

        this.setState({ savedOrders: savedOrders});

        let gratitudeAmount, taxAmount, serviceChargeAmount, deliveryCharges, totalAmount;
        if(this.state.isPricingViaToast){

            const receivedChargesViaToast = await this.getChargesViaToast(
                {
                    serviceValue: this.props.storeInfo.serviceChargeEnabled ? this.props.storeInfo.serviceCharge : 0,
                    deliveryValue: this.props.selectedLocation.deliveryCharges,
                    gratitudeValue: this.state.gratitudeCurrentValue,
                    savedOrders
                }
            );

            // gratitudeAmount = receivedChargesViaToast.gratitudeAmount;
            // taxAmount = receivedChargesViaToast.taxAmount
            // serviceChargeAmount = receivedChargesViaToast.serviceAmount
            // deliveryCharges = receivedChargesViaToast.deliveryAmount
            // totalAmount = receivedChargesViaToast.totalAmount

        }else{
            gratitudeAmount = this.formatWithoutRounding( this.state.gratitudeCurrentValue * totalPrice / 100 )
            taxAmount = this.formatWithoutRounding( this.props.storeInfo.taxEnabled ? this.props.storeInfo.taxValue * totalPrice / 100 : 0)
            serviceChargeAmount = this.formatWithoutRounding(this.props.storeInfo.serviceChargeEnabled ? this.props.storeInfo.serviceCharge * totalPrice / 100 : 0)
            deliveryCharges = this.formatWithoutRounding( this.props.selectedLocation && this.props.selectedLocation.deliveryCharges ? this.props.selectedLocation.deliveryCharges.toString().endsWith("%") ? +(totalPrice * (parseFloat(this.props.selectedLocation.deliveryCharges) / 100)) : +this.props.selectedLocation.deliveryCharges : 0)
            totalAmount = this.formatWithoutRounding( totalPrice + taxAmount + serviceChargeAmount + gratitudeAmount + deliveryCharges);

            this.setState({gratitudeAmount: gratitudeAmount})
            this.setState({taxAmount:  taxAmount})
            this.setState({serviceCharge:  serviceChargeAmount})
            this.setState({ deliveryCharges:  deliveryCharges })
            this.setState({ totalAmount:  totalAmount });

        }
      
    }


    mapImageToDataUrl = (img) => {

        console.log("mapImageToDataUrl called")

        const c = document.createElement('canvas')
        c.height = img.height;
        c.width = img.width;
        const ctx = c.getContext('2d');

        ctx.drawImage(img, 0, 0, c.width, c.height);
        const base64 = c.toDataURL();
        this.base64Map = base64;

        // console.log("map image to data url",base64);
    }

    componentDidUpdate(preProp,prevState) {

        let selectedGuestDetail

        if (preProp.deliveryLocations !== this.props.deliveryLocations) {
            if (this.props.deliveryLocations.length === 1 && !this.props.deliveryLocations[0].mapLocation == 'true') {
                this.setState({ 
                    selectedRoom: this.props.deliveryLocations[0].locationNumber,
                    selectedTime: 'Now'
                });
                this.setSelectedroom(this.props.deliveryLocations[0])
                this.props.setSelectedLocation(this.props.deliveryLocations[0]);
            }else if(this.props.deliveryLocations.length > 1){
                this.props.deliveryLocations.map(obj => {
                    if(obj.defaultLocation == true){
                        this.setState({ 
                            selectedRoom: obj.locationNumber,
                            selectedTime: 'Now'
                        });
                        this.props.setSelectedLocation(obj);
                    }
                })
            }
        }

        if(preProp.selectedLocation !== this.props.selectedLocation){
            this.props.setMapSnapshot(null);
            this.props.setCustomLocation(null);
            // console.log("custom link and image",this.props.mapSnapshot,this.props.customLocationLink)

        }
    }

    onGuestSelect = ( selectedGuest ) => {
        let selectedGuestDetail

            if (this.props.CheckedInGuest.length === 1) {
                this.props.CheckedInGuest.map((iterator) => {
                    if (iterator.guestName === this.props.guestDetail.guestName) {
                        selectedGuestDetail = iterator
                    }
                })
            }else if(this.props.CheckedInGuest.length > 1){
                this.props.CheckedInGuest.map((iterator) => {
                    if (iterator.guestName === selectedGuest) {
                        selectedGuestDetail = iterator
                    }
                })
            } else {
                console.log("No Guest name slected.");
            }
            console.log('selectedGuestDetail from onGuestSelected',selectedGuestDetail)

            // this.props.getStoreInfo(this.props.hcommerceWidget.storeSku, selectedGuestDetail);
            this.setState({storeInfoCall: false})
    }

    setRoomSelectList = () => {
        this.setState({ roomSelectList: !this.state.roomSelectList });
    }

    setTimeSelectList = () => {
        this.setState({ timeSelectList: !this.state.timeSelectList });
    }

    setGuestCountLlist = () => {
        this.setState({ showGuestCountList: !this.state.showGuestCountList})
    }

    setGuestCount = (count) => {
        this.setState({ guestCount: count, showGuestCountList: !this.state.showGuestCountList })
    }

    calculateGratitudeAndTotal = async (event) => {
        let gratitudeAmount

        this.setState({totalAmount: 0})
        // console.log('event.target.value gratitude',event.target.value)
        this.setState({gratitudeCurrentValue: event.target.value})

        let totalAmount;
        if(this.state.isPricingViaToast){

            const receivedChargesViaToast = await this.debouncedGetChargesViaToast(
                {
                    serviceValue: this.props.storeInfo.serviceChargeEnabled ? this.props.storeInfo.serviceCharge : 0,
                    deliveryValue: this.props.selectedLocation.deliveryCharges,
                    gratitudeValue: event.target.value,
                    savedOrders: this.state.savedOrders
                }
            );

            // gratitudeAmount = receivedChargesViaToast.gratitudeAmount
            // this.setState({gratitudeAmount: this.getRoundOfValue(gratitudeAmount)})
            // totalAmount = receivedChargesViaToast.totalAmount;

        }else{

            gratitudeAmount = event.target.value * this.props.totalPrice / 100
            this.setState({gratitudeAmount: this.formatWithoutRounding(gratitudeAmount)})
            totalAmount = this.props.totalPrice + this.state.taxAmount + this.state.serviceCharge + (gratitudeAmount) + +this.state.deliveryCharges
            this.setState({ totalAmount: this.formatWithoutRounding(totalAmount) })

        }
    }

    convertMapValues = (mapValues) => {

        if(!mapValues || mapValues.length === 0){
            return;
        }

        let arr = [];

        mapValues.map(el => {
            arr.push({
                "lat":el.latitude,
                "lng":el.longitude
            })
        })

        const jsonMapValues = JSON.stringify(arr);

        return jsonMapValues ? jsonMapValues : null;
    }

    goBack = () => {
        this.props.setShowPlaceOrder(false);
        this.props.setSelectedGuestName(null);
        this.props.setCustomLocation(null);
    }


    componentWillUnmount(){
        $('body').css("transform","none");
        $("body").removeClass("orders-cart");
        // this.props.setStoreInfo({});

        if(!window.location.href.includes("custom_webmap") && !window.location.href.includes("custom_location")){
            sessionStorage.removeItem("setLocationOnComponentMount")
        }
    }



    async componentDidMount(){
        let savedOrders = localStorage.getItem("savedOrders");
        let selectedGuestDetail

        let taxAmount, serviceChargeAmount, totalAmount, receivedChargesViaToast, gratitudeAmount;

        if(this.state.isPricingViaToast){
            receivedChargesViaToast = await this.getChargesViaToast(
                {
                    serviceValue: this.props.storeInfo.serviceChargeEnabled ? this.props.storeInfo.serviceCharge : 0,
                    deliveryValue: 0,
                    gratitudeValue: 0,
                    savedOrders
                }
            );

            taxAmount = receivedChargesViaToast.taxAmount;
            totalAmount = receivedChargesViaToast.totalAmount;

        }else{
            taxAmount = this.props.storeInfo.taxEnabled ? this.props.storeInfo.taxValue * this.props.totalPrice / 100 : 0
            serviceChargeAmount = this.props.storeInfo.serviceChargeEnabled ? this.props.storeInfo.serviceCharge * this.props.totalPrice / 100 : 0

            totalAmount = this.props.totalPrice + taxAmount + serviceChargeAmount + this.state.gratitudeAmount

            this.setState({taxAmount: this.formatWithoutRounding(taxAmount)})
            this.setState({serviceCharge: this.formatWithoutRounding(serviceChargeAmount)})

        }



        let room = localStorage.getItem("room");

        INROOMTAB && (!room || room == "null") && this.props.setLoginRequired(true, "You need to be checked-in to make orders")
        if(localStorage.getItem("placeOrderEventSent") !== "true"){
            // Send Analytics
                let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
                this.props.sendAnalytics(
                    this.props.guestDetail, 
                    this.props.currentWidgets.widgetType, 
                    "PLACE ORDER", 
                    {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), pageName: this.props.pageName, storeName: this.props.storeInfo.storeName}, 
                    0, 
                    this.props.guestIsLoggedIn,
                    () => localStorage.setItem("placeOrderEventSent", true)
                );
            //
        }

    this.setState({ totalAmount: totalAmount }, () => {

        this.props.getServerTime(() => {})
        if(this.props.customLocationLink && this.props.selectedLocation){
            this.setSelectedroom(this.props.selectedLocation, false)
        }

        if (savedOrders && savedOrders !== "null") {
            savedOrders = JSON.parse(savedOrders);
        } else {
            savedOrders = []
        }

        this.setState({savedOrders:savedOrders},()=>{

            // console.log("this.props.storeInfo.displayDeliveyTime",this.props.storeInfo.displayDeliveyTime, this.props.storeInfo)
            // this.props.getDeliveryLocation(this.props.hcommerceWidget.storeSku);
            if (this.props.serverTime && this.props.serverTime.hours) {
                this.setOrderTime();
            }

            if (this.props.CheckedInGuest.length === 1) {
                this.props.CheckedInGuest.map((iterator) => {
                    if (iterator.guestName === this.props.guestDetail.guestName) {
                        selectedGuestDetail = iterator
                    }
                })
            }else if(this.props.CheckedInGuest.length > 1){
                this.props.CheckedInGuest.map((iterator) => {
                    if (iterator.guestName ===this.state.selectedGuest) {
                        selectedGuestDetail = iterator
                    }
                })
            } else {
                console.log("No Guest name slected.");
            }
            console.log('selectedGuestDetail',selectedGuestDetail, this.state.selectedGuest)
            // if(this.state.selectedGuest){
            //     this.props.getStoreInfo(this.props.hcommerceWidget.storeSku, selectedGuestDetail);
            // }
            this.setState({selectedTime: 'Now'})

            if(this.props.CheckedInGuest.length === 1){
                this.setState({selectedGuest: this.props.CheckedInGuest[0].guestName})
                $('#place-order-my-order').addClass("single-guest")
            }

            let found = false
        
            if(sessionStorage.getItem("setLocationOnComponentMount") !== "true"){
                if(this.props.deliveryLocations && this.props.deliveryLocations.length > 0){
                    this.props.deliveryLocations.map((location) => {
                        if(location.locationNumber == room && !location.mapLocation){
                            this.setSelectedroom(location, false)        
                            found = true
                        }
                    })
                }

                if(!found && !this.props.storeInfo.displayAllDeliveryLocations){
                    console.log("found******");
                    this.setSelectedroom({
                        "locationNumber": room,
                        "gratitudeEnabled": this.props.storeInfo.gratitudeEnabled,
                        "gratitudeDefault": this.props.storeInfo.gratitudeConfigs ? this.props.storeInfo.gratitudeConfigs.defaultValue : 0,
                        "gratitudeMax": this.props.storeInfo.gratitudeConfigs ? this.props.storeInfo.gratitudeConfigs.maxValue : 0,
                        "gratitudeMin": this.props.storeInfo.gratitudeConfigs ? this.props.storeInfo.gratitudeConfigs.minValue : 0,
                        "deliveryCharges": this.props.storeInfo.deliveryCharge || 0
                    }, false)
                }
                sessionStorage.setItem("setLocationOnComponentMount", true)
            }
        })
    })

        // console.log("custom link and image",this.props.mapSnapshot,this.props.customLocationLink)
        $('body').css("transform","none");
        $("body").addClass("orders-cart");
        $("#place_order_header").attr("style",`!important;max-height:none;height:auto !important;position:fixed;z-index:11;width:85%;background:${this.props.menuColor.assetBackgroundSelectorColor}`);
        $("#place_order_footer").attr("style","background:#fff")
    }

    showAddonsHandler = (addons) => {

        if(!addons || addons.length === 0){
            return
        }

        const addOnNames = [];

        addons.map((obj) => {
            if(obj.quantity > 0){
                addOnNames.push(obj.name);
            }
        })

        return addOnNames.join(", ");
        
    }

    setGuestComment = (event) => {
        this.setState({guestComment: event.target.value})
        localStorage.setItem('GuestCommentHcommerce', event.target.value)
    }

    handleScroll = () => {
        hideScrolltoBottomHandler('place-order-my-order', (bool) => this.setState({ hideBottomArrow: bool }), 140)
        hideScrolltoTopHandler("place-order-my-order",(bool) => this.setState({showScrollToTop:bool}))
    }

    quantityDecrease = (iterator) => {
        if (iterator.quantity > 1) {
            // Decrease quantity
            const updatedSavedOrders = this.state.savedOrders.map(order => {
                if (order.item.id === iterator.item.id) {
                    const newQuantity = iterator.quantity - 1;
                    const newTotalPrice = iterator.item.itemPrice * newQuantity;
    
                    return {
                        ...order,
                        quantity: newQuantity,
                        totalPrice: this.formatWithoutRounding(newTotalPrice)
                    };
                }
                return order;
            });
    
            // Update localStorage
            localStorage.setItem("savedOrders", JSON.stringify(updatedSavedOrders));
    
            // Calculate new total price
            const newTotalPrice = updatedSavedOrders.reduce((total, order) => total + order.totalPrice, 0);
    
            // Update state and props
            this.props.setTotalOrderPrice(newTotalPrice);
            this.setState({ savedOrders: updatedSavedOrders }, () => {
                // Recalculate additional charges
                this.removeItemHandlerCallback(updatedSavedOrders, newTotalPrice);
                this.props.setHCommerceSavedOrders(updatedSavedOrders);
            });
        } else {
            // Remove the item when quantity becomes zero
            const updatedSavedOrders = this.state.savedOrders.filter(order => order.item.id !== iterator.item.id);
    
            // Update localStorage
            localStorage.setItem("savedOrders", JSON.stringify(updatedSavedOrders));
    
            // Calculate new total price
            const newTotalPrice = updatedSavedOrders.reduce((total, order) => total + order.totalPrice, 0);
    
            // Update state and props
            this.props.setTotalOrderPrice(newTotalPrice);
            this.setState({ savedOrders: updatedSavedOrders }, () => {
                // Recalculate additional charges
                this.removeItemHandlerCallback(updatedSavedOrders, newTotalPrice);
                this.props.setHCommerceSavedOrders(updatedSavedOrders);
            });
        }
    }

    quantityIncress = (iterator) => {
        // Create a copy of saved orders
        const updatedSavedOrders = this.state.savedOrders.map(order => {
            if (order.item.id === iterator.item.id) {
                // Increase quantity
                const newQuantity = iterator.quantity + 1;
                const newTotalPrice = iterator.item.itemPrice * newQuantity;
    
                return {
                    ...order,
                    quantity: newQuantity,
                    totalPrice: this.formatWithoutRounding(newTotalPrice)
                };
            }
            return order;
        });
    
        // Update localStorage
        localStorage.setItem("savedOrders", JSON.stringify(updatedSavedOrders));
    
        // Calculate new total price
        const newTotalPrice = updatedSavedOrders.reduce((total, order) => total + order.totalPrice, 0);
    
        // Update state and props
        this.props.setTotalOrderPrice(newTotalPrice);
        this.setState({ savedOrders: updatedSavedOrders }, () => {
            // Recalculate additional charges
            this.removeItemHandlerCallback(updatedSavedOrders, newTotalPrice);
            this.props.setHCommerceSavedOrders(updatedSavedOrders);
        });
    }

    render(){
        let imagePath = null;
        const {t} = this.props
        return(
            <div>{console.log("selectedGuestName",this.props.selectedGuestName)}

                <header class={`${(!this.props.storeInfo.displayAllDeliveryLocations && !this.props.storeInfo.displayDeliveyTime && this.props.CheckedInGuest.length == 1 ? "empty-header" : "")} inner-pages w-footer header-form`} id = "place_order_header">
                    <a class="button-back" onClick={this.goBack}></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={getCdnUrl(CMSPath, this.props.logo)} />
                        </div>
                    </div>
                </header>

                <section class="widgets">

                    <div class="widget-header">
                        <div class="widget-header-title">{t('hcommerce.checkout.my_orders')}</div>
                        <div class="widget-header-subtitle">{t('hcommerce.checkout.my_orders_subtitle')}</div>
                    </div>

                    <div class="orders-body-container app-body">
                    {this.state.savedOrders.length > 0 ? (
                        <>
                        <div class="orders-body-scroller" style={this.state.savedOrders.length > 4 ? {} : { display: "none" }}>
                            {this.state.showScrollToTop && <div onClick={() => contScrollToTop("place-order-my-order")} class="orders-scroll scroll-up"><i class="fa fas fa-chevron-up"></i></div>}
                            {!this.state.hideBottomArrow && <div onClick={() => contScrollToBottom("place-order-my-order")} class="orders-scroll scroll-down"><i class="fa fas fa-chevron-down"></i></div>}
                        </div>
                        
                        <div class="orders-body">
                            {

                                this.state.savedOrders.map((iterator) => {
                                    imagePath = null;
                                    if (iterator.item.storeItemImages.length === 1) {
                                        imagePath = `${CMSPath}${iterator.item.storeItemImages[0].imagePath}`
                                    } else {
                                        iterator.item.storeItemImages.map((images) => {
                                            if (images.imageType === "LARGE") {
                                                imagePath = encodeURI(`${CMSPath}${images.imagePath}`)
                                            }
                                        })
                                    }
                                    return (

                                        <div class="row order-row">
                                            <div class="close" style={{
                                                backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                                            }}
                                                onClick={() => removeItemHandler(iterator, this.props, this.removeItemHandlerCallback)}><i class="fa fa-times"></i></div>
                                            <div class="col col-4 order-preview" style={{ backgroundImage: `url('${imagePath}')`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", height: "100%", width: "30%", backgroundSize: "cover" }}></div>
                                           
                                           { !PROVIDE_INCREASE_DECREASE_ITEM_QUANTITY_ON_HCOM_CHECKOUT_PAGE ? 
                                                <div class="col col-4 order-details">
                                                    <div class="details">
                                                            <div class="order-name">
                                                                <p class="item-name" dangerouslySetInnerHTML={{ __html: `${iterator.item.itemName}` }}></p>
                                                            </div>
                                                            <div class="order-qty">
                                                                {(iterator.addOns && iterator.addOns.length > 0) ? <p class="item-addons">{this.showAddonsHandler(iterator.addOns)}</p> : <p class="item-addons"></p>}
                                                                <p class="item-amt" dangerouslySetInnerHTML={{ __html: `${this.props.currencyCode} ${formatPriceForDisplay(iterator.totalPrice, this.props.precisionLength)}` }}></p>
                                                            </div>
                                                    </div>
                                                    <div class="qty-order">
                                                        <p class="qty align-center">{iterator.quantity}</p>
                                                    </div>
                                                </div>
                                             :
                                                <div class="col col-4 order-details">
                                                    <div class="order-name">
                                                        <p class="item-name" dangerouslySetInnerHTML={{ __html: `${iterator.item.itemName}` }}></p>
                                                        {/* <p class="qty align-center">{iterator.quantity}</p> */}
                                                        <div class="qty align-center">
                                                                    <div class="qty-container">
                                                                        <button class="qty-minus"><span class="icon" onClick={() => this.quantityDecrease(iterator)}>-</span></button>
                                                                        <input type="number" value={iterator.quantity} />
                                                                        <button class="qty-add"><span class="icon" onClick={() => this.quantityIncress(iterator)}>+</span></button>
                                                                    </div>
                                                        </div>	
                                                    </div>
                                                    <div class="order-qty">
                                                        {(iterator.addOns && iterator.addOns.length > 0) ? <p class="item-addons">{this.showAddonsHandler(iterator.addOns)}</p> : <p class="item-addons"></p>}
                                                        <p class="item-amt" dangerouslySetInnerHTML={{ __html: `${this.props.currencyCode} ${iterator.totalPrice}` }}></p>
                                                    </div>
                                                </div>
                                             }
                                            
                                        </div>

                                    )
                                })
                            }
                        </div>

                        <div class="widget-header">
                            <div class="widget-header-title" style={{ textTransform: "uppercase", padding: "1rem", textAlign: "center" }}>{t('hcommerce.checkout.place_order')}</div>
                            <div class="widget-header-subtitle" style={{ textTransform: "uppercase", padding: "1rem", textAlign: "center" }}>{t('hcommerce.checkout.place_order_subtitle')}</div>

                        </div>

                        <div class="order-payment">

                            <div className="form-rom">
                                <div className="col-2">
                                    {(this.props.storeInfo.displayAllDeliveryLocations || !this.props.guestIsLoggedIn) && <div className={`${this.props.storeInfo.displayDeliveyTime ? "w-60 margin-right-1" : "w-100"}`}>
                                        <label className="row bold align-left">{!this.props.guestIsLoggedIn && this.props.storeInfo.allowDayGuestOrdering ? this.props.storeInfo.dayOrderingDeliveryLabel || t('hcommerce.checkout.delivery_location') : t('hcommerce.checkout.delivery_location')}<span style={{ color: "red" }}>*</span></label>
                                        <div class={`custom-select align-left`} >

                                            <div className={`select-selected ${this.state.roomSelectList ? "select-arrow-active" : ""}`} onClick={this.setRoomSelectList}>
                                                {this.state.selectedRoom ? this.state.selectedRoom : t('hcommerce.checkout.select_room')}
                                            </div>
                                            <div className={
                                                this.state.roomSelectList ?
                                                    "select-items" : "select-items select-hide"
                                            }>
                                                {
                                                    this.props.deliveryLocations.map((iterator) => {
                                                        if (iterator.mapLocation) {
                                                            // window.location.hash = "/hcommerce2?mapWasOpened=true"
                                                            return (
                                                                // <Link exact to = {`/hcommerce2/custom_location?mapValues=${this.convertMapValues(iterator.mapValues)}`}>
                                                                <div onClick={() => this.setSelectedroom(iterator, false, true)}>
                                                                    {iterator.locationNumber}
                                                                </div>
                                                                // </Link>
                                                            )
                                                        } else {
                                                            return <div onClick={() => this.setSelectedroom(iterator)}>
                                                                {iterator.locationNumber}
                                                            </div>
                                                        }

                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>}
                                    {this.props.storeInfo && this.props.storeInfo.displayDeliveyTime &&
                                        <div className={`${this.props.storeInfo.displayAllDeliveryLocations || !this.props.guestIsLoggedIn ? "w-35" : "w-100"} align-left`}>
                                            <label className="row bold align-left">{t('hcommerce.checkout.place_order_time')}</label>
                                            <div class={`custom-select align-left`}>{console.log('this.state.timeSelectList', this.state.timeSelectList)}
                                                <div className={`select-selected ${this.state.timeSelectList ? "select-arrow-active" : ""}`} onClick={this.setTimeSelectList}>
                                                    {
                                                        this.state.selectedTime ?

                                                            this.state.selectedTime
                                                            :
                                                            "Please select"
                                                    }
                                                </div>
                                                <div className={
                                                    this.state.timeSelectList ?
                                                        "select-items" : "select-items select-hide"
                                                }>
                                                    {
                                                        this.state.orderTime.map((iterator) => {
                                                            return (
                                                                <div
                                                                    onClick={() => this.setSelectedTime(iterator.time)}>
                                                                    {iterator.time}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                            {this.props.guestIsLoggedIn ? this.props.CheckedInGuest.length !== 1 && <div class="form-row" style={{ zIndex: "5" }}>
                                <label id="guest-name" for="cust-name" class="align-left">{t('hcommerce.checkout.your_name')}<span style={{ color: "red" }}>*</span></label>
                                <GuestSelectDropdown
                                    selectedItem={this.state.selectedGuest}
                                    listData={this.props.CheckedInGuest}
                                    showList={this.state.showGuestList}
                                    setShowList={() => this.setState(prev => ({ showGuestList: !prev.showGuestList }))}
                                    setSelectedItem={(obj) => {
                                        this.setState({ selectedGuest: obj.guestName, showGuestList: false })
                                        this.state.selectedGuest && this.state.storeInfoCall && this.onGuestSelect(obj.guestName)
                                    }}
                                    selectKey="obj.guestName"
                                />
                            </div>
                                :
                                <div class="form-row">
                                    <div class="margin-right-1">
                                        <label for="cust-name" class="align-left">E-mail {!this.NotMandEmailStoreSku.includes(this.props.hcommerceWidget.storeSku) && <span style={{ color: 'red' }} >* </span>} <span style={{ fontWeight: '300' }}>(Staying with us? <a style={{ color: '#fff', textDecoration: 'underline' }} onClick={() => this.props.setGuestLogin(true)} >Login here</a>)</span></label>
                                        <input type="email" value={this.state.guestEmail} name="email" onChange={(e) => this.setState({ guestEmail: e.target.value })} />
                                    </div>
                                </div>
                            }

                            {
                                this.props.storeInfo.guestCountEnabled && 
                                <div class="form-row" style = {{zIndex:"5"}}>
                                    <label id="guest-count" for="guest-cout" class="align-left">{t('hcommerce.checkout.guest_count')}<span style={{color:"red"}}>*</span></label>
                                    <div class={`custom-select align-left`}>
                                        <div className={`select-selected`} onClick={this.setGuestCountLlist}>{this.state.guestCount}</div>
                                        <div className={this.state.showGuestCountList ? "select-items" : "select-items select-hide"}>
                                            {
                                                this.state.guestCountData.map((iterator) => {
                                                    return (
                                                        <div
                                                            onClick={() => this.setGuestCount(iterator)}>
                                                            {iterator}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            }


                            <div class="form-row">
                                <label>{t('hcommerce.checkout.additional_request')}</label>
                                <textarea value={this.state.guestComment} onChange={this.setGuestComment} rows="5" placeholder={t('hcommerce.checkout.additional_request_placeholder')}></textarea>
                            </div>

                            <div class="form-row">
                                    { ( !this.state.errorWhilePricingFetching && !this.state.priceFetchingInProcess  ) ?
                                          
                                                this.state.isPricingViaToast ?
                                                <>
                                                 { this.state.chargesDataViaToast && <>

                                                    { this.state.chargesDataViaToast.appliedServiceCharges && this.state.chargesDataViaToast.appliedServiceCharges.length >0  && this.state.chargesDataViaToast.appliedServiceCharges.map(appliedCharge=>
                                                        <> <div class="row">
                                                            <div class="col-2">
                                                                <div class="w-50 padding-top-1 ">{`${appliedCharge.name}`}</div>
                                                                <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {`${appliedCharge.chargeAmount}`}</div>
                                                            </div>
                                                            </div>
                                                        </> 
                                                        )
                                                    }
                                                    { this.state.chargesDataViaToast.taxAmount && 
                                                            <div class="row">
                                                                <div class="col-2">
                                                                    <div class="w-50 padding-top-1 ">Tax</div>
                                                                    <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {`${this.state.chargesDataViaToast.taxAmount}`}</div>
                                                                </div>
                                                            </div>
                                                    }
                                                                                          
                                                     <div class="row totals">
                                                        <div class="col-2">
                                                            <div class="w-50 padding-top-1">{t('hcommerce.checkout.order_total')}</div>
                                                            <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} { this.state.chargesDataViaToast.totalAmount }</div>
                                                        </div>
                                                     </div>
                                                    
                                                 </>
                                                    
                                                 }

                                                </>
                                                :
                                                <>
                                                        <div class="row">
                                                            <div class="col-2">
                                                                <div class="w-50 padding-top-1">Subtotal Amount</div>
                                                                <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {formatPriceForDisplay(this.props.totalPrice, this.props.precisionLength)}</div>
                                                            </div>
                                                        </div>

                                                       {this.state.showDeliveryCharges &&
                                                    <div class="row">
                                                        <div class="col-2">
                                                            <div class="w-50 padding-top-1">Delivery Fee</div>
                                                            <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {formatPriceForDisplay(this.state.deliveryCharges, this.props.precisionLength)}</div>
                                                            </div>
                                                    </div>
                                                }
                                                { this.props.storeInfo.serviceChargeEnabled &&
                                                    <div class="row">
                                                        <div class="col-2">
                                                            <div class="w-50 padding-top-1 ">Service Charge ({`${this.props.storeInfo.serviceCharge}`}%)</div>
                                                            <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {formatPriceForDisplay(this.state.serviceCharge, this.props.precisionLength)}</div>
                                                            </div>
                                                    </div> 
                                                }
                                                {this.props.storeInfo.taxEnabled &&
                                                    <div class="row">
                                                        <div class="col-2">
                                                            <div class="w-50 padding-top-1 ">Tax {`(${this.props.storeInfo.taxValue}%)`}</div>
                                                            <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {formatPriceForDisplay(this.state.taxAmount, this.props.precisionLength)}</div>
                                                            </div>
                                                    </div>
                                                }
                                                {this.state.showGratitudeSlider &&
                                                    <><div class="form-row gratitude">
                                                        {/* <label for="range">Gratitude rate (Drag slider to adjust):</label> */}
                                                            <div class="col-2">
                                                                <div class="w-50 padding-top-1">{t('hcommerce.checkout.gratitude')} ({`${this.state.gratitudeCurrentValue}`}%)</div>
                                                                <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {formatPriceForDisplay(this.state.gratitudeAmount, this.props.precisionLength)}</div>
                                                         </div>
                                                         <div class="range" style={{display:"flex",flexDirection:"column"}}>
                                                         <input
                                                                type="range"
                                                                min={`${this.props.selectedLocation && this.props.selectedLocation.gratitudeMin
                                                                    ? this.props.selectedLocation.gratitudeMin
                                                                    : this.state.gratitudeMin}`}
                                                                max={`${this.props.selectedLocation && this.props.selectedLocation.gratitudeMax
                                                                    ? this.props.selectedLocation.gratitudeMax
                                                                    : this.state.gratitudeMax}`}
                                                                value={`${this.state.gratitudeCurrentValue ? this.state.gratitudeCurrentValue : this.state.gratitudeDefault}`}
                                                                onChange={this.calculateGratitudeAndTotal}
                                                                class="cutom-slider" id="gratitude" />
                                                                  <div class="min-max" style={{display:"flex",justifyContent:"space-between"}}>
                                                            <span class="min-range">{`${(this.props.selectedLocation && this.props.selectedLocation.gratitudeMin) ? this.props.selectedLocation.gratitudeMin : this.state.gratitudeMin}`}%</span>
                                       
                                                            <span class="min-range">{`${this.props.selectedLocation && this.props.selectedLocation.gratitudeMax ? this.props.selectedLocation.gratitudeMax : this.state.gratitudeMax}`}%</span>
                                                        </div>
                                                        </div>
                                                    </div></>
                                                }
                                                <div class="row totals">
                                                    <div class="col-2">
                                                        <div class="w-50 padding-top-1">{t('hcommerce.checkout.order_total')}</div>
                                                        <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {this.state.totalAmount.toFixed(this.props.precisionLength)}</div>
                                                    </div>
                                                </div>

                                                </>
     
                                        :
                                        <>
                                            {this.state.priceFetchingInProcess && 
                                                    <>
                                                        <div class="loader">
                                                            <MiniLoader />
                                                        </div>
                                                    </> 
                                            }
                                            { this.state.errorWhilePricingFetching && <div class="order-price-error">
                                                <p class="align-center">{t('hcommerce.fetch_price.error')}</p>
                                                <button onClick={this.retryPriceFetching} >{t('hcommerce.fetch_price.retry')} </button>
                                            </div>
                                            }
                                        </>
                                     }
                            </div>  
                            {this.props.storeInfo.freeText &&
                                <h2>{this.props.storeInfo.freeText}</h2>
                            }
                        </div>
                 </>
                    ) : (
                        this.state.isPricingViaToast && this.state.priceFetchingInProcess ?
                        <>
                         <div class="loader">
                           <MiniLoader />
                        </div>
                        </>
                        :
                        <div class="row order-row">
                            <div class="col order-details">
                                <p class="align-center">{t('hcommerce.checkout.no_item_cart')}</p>
                            </div>
					    </div>
                    )}
                    </div>
                </section>

                {/* <header class={`${(!this.props.storeInfo.displayAllDeliveryLocations && !this.props.storeInfo.displayDeliveyTime && this.props.CheckedInGuest.length == 1 ? "empty-header" : "")} inner-pages w-footer header-form`} id = "place_order_header">
                    <a onClick = {() => {this.props.setShowPlaceOrder(false);this.props.setSelectedGuestName(null);this.props.setCustomLocation(null);}} class="button-back"></a>
                    <div class="heading align-center">
                        <p class="bold">{t('hcommerce.checkout.place_order')}</p>
                        <div className="form-rom">
                            <div className="col-2">
                                {(this.props.storeInfo.displayAllDeliveryLocations || !this.props.guestIsLoggedIn) && <div className={`${this.props.storeInfo.displayDeliveyTime ? "w-60 margin-right-1" : "w-100" }`}>
                                    <label className="row bold align-left">{ !this.props.guestIsLoggedIn && this.props.storeInfo.allowDayGuestOrdering ? this.props.storeInfo.dayOrderingDeliveryLabel || t('hcommerce.checkout.delivery_location') : t('hcommerce.checkout.delivery_location')}<span style={{color:"red"}}>*</span></label>
                                    <div class={`custom-select align-left`} >
                                    
                                    <div className={`select-selected ${this.state.roomSelectList ? "select-arrow-active" : ""}`} onClick={this.setRoomSelectList}>
                                        {this.state.selectedRoom && this.state.selectedRoom != "null" && this.state.selectedRoom != ""  ? this.state.selectedRoom : t('hcommerce.checkout.select_room')}
                                    </div>
                                    <div className={
                                        this.state.roomSelectList ?
                                            "select-items" : "select-items select-hide"
                                    }>
                                        {
                                            this.props.deliveryLocations.map((iterator) => {
                                                if (iterator.mapLocation){
                                                    // window.location.hash = "/hcommerce2?mapWasOpened=true"
                                                    return(
                                                    // <Link exact to = {`/hcommerce2/custom_location?mapValues=${this.convertMapValues(iterator.mapValues)}`}>
                                                        <div onClick={() => this.setSelectedroom(iterator, false, true)}>
                                                            {iterator.locationNumber}
                                                        </div>
                                                    // </Link>
                                                    )
                                                } else {
                                                    return <div onClick={() => this.setSelectedroom(iterator)}>
                                                            {iterator.locationNumber}
                                                        </div>
                                                }
                                                
                                            })
                                        }
                                    </div>
                                </div>
                                </div>}
                                {this.props.storeInfo && this.props.storeInfo.displayDeliveyTime &&
                                    <div className={`${this.props.storeInfo.displayAllDeliveryLocations || !this.props.guestIsLoggedIn ? "w-35" : "w-100" } align-left`}>
                                        <label className="row bold align-left">Time</label> 
                                            <div class={`custom-select align-left`}>{console.log('this.state.timeSelectList',this.state.timeSelectList)}
                                                <div className={`select-selected ${this.state.timeSelectList ? "select-arrow-active" : ""}`} onClick={this.setTimeSelectList}>
                                                    {
                                                    this.state.selectedTime ? 
                                                    
                                                    this.state.selectedTime
                                                    : 
                                                    "Please select"
                                                    }
                                                </div>
                                                <div className={
                                                    this.state.timeSelectList ?
                                                        "select-items" : "select-items select-hide"
                                                }>
                                                    {
                                                        this.state.orderTime.map((iterator) => {
                                                            return (
                                                                <div
                                                                    onClick={() => this.setSelectedTime(iterator.time)}>
                                                                    {iterator.time}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div> 
                                    </div>}
                            </div>
                        </div>
                        {this.props.guestIsLoggedIn ? this.props.CheckedInGuest.length !== 1 && <div class="form-row" style = {{zIndex:"5"}}>
                            <label id="guest-name" for="cust-name" class="align-left">{t('hcommerce.checkout.your_name')}<span style={{color:"red"}}>*</span></label>
                            <GuestSelectDropdown  
                                selectedItem={this.state.selectedGuest}
                                listData={this.props.CheckedInGuest}
                                showList={this.state.showGuestList}
                                setShowList={() => this.setState(prev => ({showGuestList: !prev.showGuestList}))}
                                setSelectedItem={(obj) => {
                                    this.setState({selectedGuest:obj.guestName, showGuestList:false})
                                    this.state.selectedGuest && this.state.storeInfoCall && this.onGuestSelect(obj.guestName)
                                }}
                                selectKey="obj.guestName"
                            />
                        </div>
                    :
                        <div class="form-row">
                            <div class="margin-right-1">
                                <label for="cust-name" class="align-left">E-mail {!this.NotMandEmailStoreSku.includes(this.props.hcommerceWidget.storeSku) && <span style={{color: 'red'}} >* </span>} <span style={{fontWeight: '300'}}>(Staying with us? <a style={{color: '#fff', textDecoration: 'underline'}} onClick={() => this.props.setGuestLogin(true)} >Login here</a>)</span></label>
                                <input type="email" value={this.state.guestEmail} name="email" onChange={(e) => this.setState({guestEmail: e.target.value}) } />
                            </div>
                        </div>
                    }

                    {
                        this.props.storeInfo.guestCountEnabled && 
                        <div class="form-row" style = {{zIndex:"5"}}>
                            <label id="guest-count" for="guest-cout" class="align-left">{t('hcommerce.checkout.guest_count')}<span style={{color:"red"}}>*</span></label>
                            <div class={`custom-select align-left`}>
                                <div className={`select-selected`} onClick={this.setGuestCountLlist}>{this.state.guestCount}</div>
                                <div className={this.state.showGuestCountList ? "select-items" : "select-items select-hide"}>
                                    {
                                        this.state.guestCountData.map((iterator) => {
                                            return (
                                                <div
                                                    onClick={() => this.setGuestCount(iterator)}>
                                                    {iterator}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    }
                                
                    </div>
                </header>
                <section id="place-order-my-order" onScroll={this.handleScroll} class="widgets" style={{paddingBottom: "10rem"}}>
                    <div class="orders-body-container app-body">
                        <div class="orders-body-scroller" style={this.state.savedOrders.length > 4 ? {} : { display: "none" }}>
                            {this.state.showScrollToTop && <div onClick={() => contScrollToTop("place-order-my-order")} class="orders-scroll scroll-up"><i class="fa fas fa-chevron-up"></i></div>}
                            {!this.state.hideBottomArrow && <div onClick={() => contScrollToBottom("place-order-my-order")} class="orders-scroll scroll-down"><i class="fa fas fa-chevron-down"></i></div>}
                        </div>
                        <div class="orders-body">
                            {
                                
                                this.state.savedOrders.map((iterator) => {
                                    imagePath = null;
                                    if (iterator.item.storeItemImages.length === 1) {
                                        imagePath = getCleanUrl(`${iterator.item.storeItemImages[0].imagePath}`)
                                    } else {
                                        iterator.item.storeItemImages.map((images) => {
                                            if (images.imageType === "LARGE") {
                                                imagePath = encodeURI(getCleanUrl(`${images.imagePath}`))
                                            }
                                        })
                                    }
                                    return (
                                    
                                        <div class="row order-row">
                                            <div class="close" style = {{
                                                backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                                            }}
                                            onClick = {() => removeItemHandler(iterator, this.props,this.removeItemHandlerCallback)}><i class="fa fa-times"></i></div>
                                            <div class="col col-4 order-preview" style={{backgroundImage: `url('${imagePath}')`, backgroundSize:"cover", backgroundPosition:"center",backgroundRepeat:"no-repeat", height: "100%", width: "30%",backgroundSize: "cover"}}></div>
                                            <div class="col col-4 order-details">
                                                <div class="order-name">
                                                    <p class="item-name" dangerouslySetInnerHTML={{__html: `${iterator.item.itemName}`}}></p>
                                                    <p class="qty align-center">{iterator.quantity}</p>								
                                                </div>
                                                <div class="order-qty">
                                                    {(iterator.addOns && iterator.addOns.length > 0) ? <p class="item-addons">{this.showAddonsHandler(iterator.addOns)}</p> : <p class="item-addons"></p>}
                                                    <p class="item-amt" dangerouslySetInnerHTML={{__html: `${this.props.currencyCode} ${iterator.totalPrice}`}}></p>
                                                </div> 
                                            </div>
                                        </div>

                                    )
                                })
                            }
                   
                        </div>

                        <div class="order-payment">
                            { this.state.showGratitudeSlider &&
                                <><div class="form-row gratitude">
                                    <label for="range">Gratitude rate (Drag slider to adjust):</label>
                                    <div class="range">
                                        <span class="min-range">{`${(this.props.selectedLocation && this.props.selectedLocation.gratitudeMin) ? this.props.selectedLocation.gratitudeMin : this.state.gratitudeMin}`}%</span>
                                        <input 
                                            type="range" 
                                            min={`${this.props.selectedLocation && this.props.selectedLocation.gratitudeMin 
                                                    ? this.props.selectedLocation.gratitudeMin 
                                                    : this.state.gratitudeMin}`} 
                                            max={`${this.props.selectedLocation && this.props.selectedLocation.gratitudeMax 
                                                    ? this.props.selectedLocation.gratitudeMax 
                                                    : this.state.gratitudeMax}`} 
                                            value={`${this.state.gratitudeCurrentValue ? this.state.gratitudeCurrentValue : this.state.gratitudeDefault}`} 
                                            onChange={this.calculateGratitudeAndTotal} 
                                            class="cutom-slider" id="gratitude"/>
                                        <span class="min-range">{`${this.props.selectedLocation && this.props.selectedLocation.gratitudeMax ? this.props.selectedLocation.gratitudeMax : this.state.gratitudeMax}`}%</span>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-2">
                                        <div class="w-50 padding-top-1">Gratitude ({`${this.state.gratitudeCurrentValue}`}%)</div>
                                        <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {`${this.state.gratitudeAmount.toFixed(this.props.precisionLength)}`}</div>
                                    </div>
                                </div></>
                            }
                            { this.state.showDeliveryCharges &&
                                <div class="row">
                                    <div class="col-2">
                                        <div class="w-50 padding-top-1">Delivery Fee</div>
                                        <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {`${this.state.deliveryCharges.toFixed(this.props.precisionLength)}`}</div>
                                    </div>
                                </div>
                            }
                            { this.props.storeInfo.serviceChargeEnabled &&
                                <div class="row">
                                    <div class="col-2">
                                        <div class="w-50 padding-top-1 ">Service Charge ({`${this.props.storeInfo.serviceCharge}`}%)</div>
                                        <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {`${this.state.serviceCharge.toFixed(this.props.precisionLength)}`}</div>
                                    </div>
                                </div> 
                            }
                            { this.props.storeInfo.taxEnabled &&
                                <div class="row">
                                    <div class="col-2">
                                        <div class="w-50 padding-top-1 ">Tax ({`${this.props.storeInfo.taxValue}`}%)</div>
                                        <div class="w-50 padding-top-1 bold align-right">{this.props.currencyCode} {`${this.state.taxAmount.toFixed(this.props.precisionLength)}`}</div>
                                    </div>
                                </div> 
                            }
                        </div>
                        
                    </div>
                </section> */}
                
                <footer class="button-controls" id = "place_order_footer">
                    {/* <div class="col-2" style = {{color:"#000"}}>
                        <div class="w-45 padding-top-1 padding-bottom-1 padding-left-1">{t('hcommerce.checkout.order_total')}</div>
                        <div class="w-45 padding-top-1 padding-bottom-1 padding-right-1 bold align-right">{this.props.currencyCode} {this.state.totalAmount.toFixed(this.props.precisionLength)}</div>
                    </div> */}
                    <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                    {this.state.savedOrders.length > 0 ? ( <button class="primary w-100 all-caps" style = {{
                            backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                        }} onClick={this.placeOrder} disabled={this.state.placeOrderInProgress || this.props.storeInfo.disableOrder}>{t('hcommerce.checkout.place_order')}</button>):
                        <></>
                        }
                        <button class="secondary w-100 all-caps" style = {{
                            backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                        }} onClick={this.goBack} disabled={this.state.placeOrderInProgress}>{t('hcommerce.checkout.back')}</button>
                    </section>
                </footer>
                {this.state.showMap ? WEB_VERSION_ENABLED ?
                <HashRouter>
                    <Redirect exact to="/hcommerce2/custom_webmap"/>
                </HashRouter> :
                <HashRouter>
                    <Redirect exact to="/hcommerce2/custom_location"/>
                </HashRouter>: null}
                {
                    this.state.placeOrderInProgress && <Loader displayMsg={"Sending data"}/>
                }
                {
                    this.props.storeInfo.disableOrder && this.props.storeInfo.htmlInstruction && <OrderDisabledPopup close={() => this.props.setShowPlaceOrder(false)} htmlString={this.props.storeInfo.htmlInstruction}/>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        // currentPage: state.store.Hcommerce.currentPage,
        serverTime: state.store.home.serverTimeDate.time,
        CheckedInGuest: state.store.CheckedInGuest,
        currentWidget: state.store.sideNavBar.currentWidget,
        // serverDate: state.store.home.serverTimeDate,
        deliveryLocations: state.store.Hcommerce.deliveryLocations,
        storeInfo: state.store.Hcommerce.storeInfo,
        menuColor: state.store.home.MenuColor,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        precisionLength: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.precisionLength : "",
        totalPrice: state.store.Hcommerce.totalPrice,
        selectedLocation: state.store.Hcommerce.selectedLocation,
        customLocationLink: state.store2.locationLink,
        mapSnapshot: state.store2.mapSnapshot,
        hcommerceWidget: state.store2.hcommerceWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        selectedGuestName: state.store2.selectedGuestName,
        hcommerce_zoom_mapview: state.store.home.clientConfig.extraConfigParam
        ? state.store.home.clientConfig.extraConfigParam.HCOMMERCE_ZOOM_MAPVIEW : '{"zoomLevel" : "20", "mapView" : "k"}',
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        isPricingViaToast: state.store.Hcommerce.isPricingViaToast,
        reservationNo: state.store.reservationNo,
    }
}

export default connect(mapStateToProps,{
     changePage,
     sendOrder,
     // popupOpenClose,
     // setLoadingMass,
     getDeliveryLocation,
     // setOrderDetailPage,
     closeOrderPopUp,
     setTotalOrderPrice,
     setCustomLocation,
     setSelectedLocation,
     getStoreInfo,
     setMapSnapshot,
     setShowPlaceOrder,
     setHCommerceSavedOrders,
     setStoreInfo,
     getServerTime,
     setRegPage,
     setGuestLogin,
     setSelectedGuestName,
     setLoginRequired,
     sendAnalytics,
     popupOpenClose,
     setMapOpened,
     setSelectedSubItemListStoreLevel2,
     setSelectedSubItemStoreLevel2
})(withTranslation('translations')(PlaceOrderNew));